import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE_URL = "https://alturaconciergerie.com";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/545976fc-774f-4132-bae0-c645581525da/images/3e3764c5a2fa976bdd067e7b8c5b99ebcb8024cb330a1b6662a58a51f67e4c6a.jpeg";

const LANG_MAP = { fr: "fr_FR", en: "en_GB", es: "es_ES" };

const SEO = ({ title, description, path = "/", noindex = false }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "fr";
  const fullTitle = title ? `${title} | ALTURA` : "ALTURA Services — Transport & Nettoyage Premium";
  const fullUrl = `${SITE_URL}${path}`;
  const defaultDesc = "ALTURA Services : transport privé de luxe et nettoyage professionnel à Paris et en Île-de-France. Chauffeurs, transferts, nettoyage automobile, mobilier et appartement.";
  const desc = description || defaultDesc;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={LANG_MAP[lang] || "fr_FR"} />
      <meta property="og:site_name" content="ALTURA Services" />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1600" />
      <meta property="og:image:height" content="900" />
      <meta property="og:image:alt" content="ALTURA Services — Transport & Nettoyage Premium" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* Hreflang for multilingual SEO */}
      <link rel="alternate" hrefLang="fr" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="es" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />
    </Helmet>
  );
};

export default SEO;
